import { render, staticRenderFns } from "./CookieListItem.vue?vue&type=template&id=21554164&"
import script from "./CookieListItem.vue?vue&type=script&lang=js&"
export * from "./CookieListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports